export default __webpack_public_path__ + "static/media/Imagen.92946e5a.svg";